import axios from "axios";
import React, { useState, useEffect } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useParams, Redirect } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { API_URL, NEW_API_URL } from "../../../constants/Globals";
import { connect } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import Autosuggest from "react-autosuggest";
import NetworksSelector from "../../NetworksSelector";
import OrganizationSelector from "../../OrganizationSelector";
import { isUserHasValidRoleForGroup } from "../../../services/GroupSvc";
var moment = require("moment-timezone");

const AddEditCampaign = ({ selNetworkId, allNetworks = [], groups = [] }) => {
  const [id, setId] = useState(useParams().id);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  // const [debateId, setDebateId] = useState("");
  // const [debateTitle, setDebateTitle] = useState("");
  // const [formId, setFormId] = useState(null);
  // const [sequenceId, setSequenceId] = useState(null);
  const [cTypeId, setCTypeId] = useState("");
  const [cTypeTitle, setCTypeTitle] = useState("");
  const [responseCountTarget, setResponseCountTarget] = useState(100);
  const [contentTypeValue, setContentTypeValue] = useState("Poll");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [scope, setScope] = useState("All Sites");
  const [isRecordSaved, setIsRecordSaved] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [ctContentList, setCtContentList] = useState([]);
  const [forNetworks, setForNetworks] = useState([]);
  const [forGroups, setForGroups] = useState([]);
  const [groupNetworks, setGroupNetworks] = useState([]);
  const [isLoggedInUserSuperAdmin, setIsLoggedInUserSuperAdmin] =
    useState(false);
  const [sidedDefaultOrgId, setSidedDefaultOrgId] = useState(0);
  const [isActive, setIsActive] = useState(1);
  const [isSponsored, setIsSponsored] = useState(1);

  const getSidedDefaultOrganization = async () => {
    const defaultOrgDetail = await axios
      .get(`${NEW_API_URL}/master/groups/sided`, {
        params: {},
      })
      .then(({ data }) => data.data);
    return defaultOrgDetail;
  };
  useEffect(() => {
    const checkGroupsCount = () => {
      if (groups && groups.length === 1) {
        setForGroups([groups[0].groupId]);
      }
    };
    const checkUserRole = async () => {
      const isUserSuperAdmin = await isUserHasValidRoleForGroup(
        0,
        "SUPERADMIN"
      );
      console.log("Is Super Admin:", isUserSuperAdmin);
      setIsLoggedInUserSuperAdmin(isUserSuperAdmin);
      if (isUserSuperAdmin) {
        const defaultOrgDetail = await getSidedDefaultOrganization();
        setSidedDefaultOrgId(defaultOrgDetail.id);
      }
    };
    checkGroupsCount();
    checkUserRole();
  }, []);

  useEffect(() => {
    if (
      !forGroups ||
      forGroups.length === 0 ||
      forGroups[0] === null ||
      forGroups[0] === undefined
    ) {
      setGroupNetworks([]);
      return;
    }
    if (forGroups && forGroups.length > 0) {
      Promise.all(
        forGroups.map((groupId) =>
          axios
            .get(`${API_URL}/admin/groups/getGroupNetworks`, {
              params: {
                groupId,
                pageNumber: 1,
                perPage: 100,
                orderBy: "name",
                order: "asc",
              },
            })
            .then(({ data }) => data.data)
        )
      ).then((results) => {
        const allNetworks = [].concat(...results);
        const uniqueNetworks = Array.from(
          new Map(allNetworks.map((n) => [n.id, n])).values()
        );
        setGroupNetworks(uniqueNetworks);
      });
    } else {
      setGroupNetworks([]);
    }
  }, [forGroups]);
  const [isClosed, setIsClosed] = useState(false);
  const [responseList, setResponseList] = useState([
    1, 5, 10, 50, 100, 200, 300, 400, 500, 1000, 2000, 5000, 10000,
  ]);
  const [slotNumberList, setSlotNumberList] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ]);
  const [slotNumber, setSlotNumber] = useState(1);
  const [campaignScope, setCampaignScope] = useState([
    "All Sites",
    "Specific Sites",
  ]);
  const [contentTypesList, setContentTypesList] = useState([
    "Poll",
    "Sequence",
  ]);
  // const endedAtMinDate = moment().add(5, "minutes");
  const kTrans = (str) => str;
  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
  };

  useEffect(() => {
    if (id > 0) {
      axios.get(`${NEW_API_URL}/campaigns/${id}`).then(({ data }) => {
        const response = data;
        setId(response.data.id);
        setTitle(response.data.title);
        setDescription(response.data.description);
        setResponseCountTarget(response.data.responseCountTarget);
        setSlotNumber(response.data.slotNumber);
        setStartDate(moment(response.data.startDate));
        setEndDate(moment(response.data.endDate));
        setIsActive(response.data.isActive);
        setIsSponsored(response.data.isSponsored);
        if (response.data.forNetworks.length > 0) {
          setScope("Specific Sites");
        } else {
          setScope("All Sites");
        }
        if (response.data.debateId != null) {
          setContentTypeValue("Poll");
          setCTypeId(response.data.debateId);
          setCTypeTitle(response.data.campaignDebate?.thesis ?? "");
          setSearchInput(response.data.campaignDebate?.thesis ?? "");
        } else if (response.data.sequenceId) {
          setContentTypeValue("Sequence");
          setCTypeId(response.data.sequenceId);
          setCTypeTitle(response.data.campaignSequence?.name ?? "");
          setSearchInput(response.data.campaignSequence?.name ?? "");
        }
        setForNetworks(response.data.forNetworks, []);
        setForGroups(response.data.forGroups || []);
        setIsClosed(response.data.isClosed);
        console.log(response.data);
      });
    } else {
      setStartDate(moment());
      setEndDate(moment().add(7, "days"));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (title.trim() === "") {
      alert("Please enter campaign title.");
      return false;
    }
    // if (debateId === "") {
    //   alert("Please select a poll.");
    //   return false;
    // }
    if (cTypeId === "") {
      alert("Please select a poll, quiz or sequence.");
      return false;
    }
    let campDebateId = null;
    let campSequenceId = null;
    let campFormId = null;
    if (contentTypeValue === "Poll") {
      campDebateId = cTypeId;
    } else if (contentTypeValue === "Sequence") {
      campSequenceId = cTypeId;
    } else {
      alert("Not a valid type.");
      return false;
    }
    if (startDate === null) {
      alert("Please select start date.");
      return false;
    }
    if (endDate === null) {
      alert("Please select end date.");
      return false;
    }
    if (startDate.isAfter(endDate)) {
      alert("Start date must be before end date.");
      return false;
    }
    if (scope === "Specific Sites" && forNetworks.length === 0) {
      alert("Please select sites.");
      return false;
    }

    try {
      const url =
        id > 0 ? `${NEW_API_URL}/campaigns/${id}` : `${NEW_API_URL}/campaigns`;
      const method = id > 0 ? "PUT" : "POST";

      let addEditPayload = {
        id: id,
        title: title,
        description: description,
        debateId: campDebateId,
        formId: campFormId,
        sequenceId: campSequenceId,
        responseCountTarget: responseCountTarget,
        startDate: startDate,
        endDate: endDate,
        runFor: "networks",
        forNetworks: scope == "All Sites" ? [] : forNetworks,
        responseCount: 0,
        slotNumber: slotNumber,
        // forGroups: forGroups.length > 0 ? forGroups : groups.map((g) => g.groupId),
        forGroups: 0,
        isActive: isActive,
        isSponsored: isSponsored,
      };

      let groupVal = forGroups;
      console.log("For groupsssssssssssssssss", groupVal);
      if (Array.isArray(groupVal)) {
        if (groupVal.length > 0) {
          groupVal = groupVal[0];
        } else {
          groupVal = 0;
        }
      }
      if (groupVal) {
        addEditPayload.forGroups = [groupVal];
      } else {
        if (isLoggedInUserSuperAdmin) {
          addEditPayload.forGroups = [sidedDefaultOrgId];
        } else {
          alert("Please provide group.");
          return false;
        }
      }

      if (scope === "Specific Sites") {
        addEditPayload.forNetworks = (forNetworks || []).map((n) => n.id ?? n);
      } else {
        addEditPayload.forNetworks = [];
      }

      if (isLoggedInUserSuperAdmin && scope === "All Sites") {
        addEditPayload.forNetworks = [];
      }

      axios
        .request({
          url,
          method,
          data: addEditPayload,
        })
        .then(({ data }) => {
          const response = data;
          setScope("All Sites");
          console.log(response.data);
          setIsRecordSaved(true);
        });
    } catch (error) {
      console.error("Error saving campaign:", error);
    }
  };

  const handleResponseDropdownChange = async (e, response) => {
    e.preventDefault();
    setResponseCountTarget(response);
  };

  const handleContentTypeDDChange = async (e, response) => {
    e.preventDefault();
    setCTypeTitle("");
    setCTypeId("");
    setSearchInput("");
    setContentTypeValue(response);
  };
  const handleSlotNumberDropdownChange = async (e, response) => {
    e.preventDefault();
    response === "N/A" ? setSlotNumber(null) : setSlotNumber(response);
  };

  const handleScopeDropdownChange = async (e, response) => {
    e.preventDefault();
    setScope(response);
  };

  const handlePollSearchOnChange = (event) => {
    setSearchInput(event.target.value);
  };

  const searchCampaignContent = async () => {
    if (debouncedSearch !== cTypeTitle) {
      var selGroupId = forGroups && forGroups.length > 0 ? forGroups[0] : 0;
      if ((selGroupId == 0 || selGroupId == null) && sidedDefaultOrgId > 0) {
        selGroupId = sidedDefaultOrgId;
      }
      if (!selGroupId) {
        alert("Please select organization.");
        return;
      }
      var selNetworkIds =
        forNetworks && forNetworks.length > 0 ? forNetworks : [];

      if (contentTypeValue === "Poll") {
        axios
          .get(
            API_URL +
              `/admin/debate/getGroupNetworksDebates?isActive=1&perPage=5&pageNumber=1&groupId=${selGroupId}&clientIds=${selNetworkIds.join(",")}&searchText=${debouncedSearch.trim()}`
          )
          .then(({ data }) => setCtContentList(data.data.rows));
      } else if (contentTypeValue === "Sequence") {
        axios
          .get(
            API_URL +
              `/collections/listByGroup?groupId=${selGroupId}&clientIds=${selNetworkIds.join(",")}&searchText=${debouncedSearch.trim()}&pageNumber=1&perPage=5`
          )
          .then(({ data }) => setCtContentList(data.data.rows));
      }
    }
  };

  const debouncedSearch = useDebounce(searchInput, 500);
  const handleDropdownSelect = async (selectedPoll) => {
    setCTypeId(selectedPoll.id);
    setCTypeTitle(selectedPoll.contentTypeDesc);
  };

  useEffect(() => {
    if (debouncedSearch) searchCampaignContent();
  }, [debouncedSearch]);

  const onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSearchInput(value);
    // searchCampaignContent();
  };

  const onSuggestionsClearRequested = () => {
    setCtContentList([]);
  };

  if (isRecordSaved) {
    return <Redirect to="/campaigns" />;
  }

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Advertising</strong>&nbsp;|&nbsp;
          {id == "0" ? "Add New Campaign" : "Edit Campaign"}
          {isClosed ? " (Closed)" : ""}
        </div>
      </div>
      <div className="add-edit-campaign">
        <Form onSubmit={handleSubmit} className="common-form sided-form">
          <Form.Group className="border-bottom pb-4 d-flex">
            <div className="w-100">
              <Form.Label>
                <b className="text-sm-start">{kTrans("Name this campaign")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                id="title"
                name="title"
                className="w-50"
                placeholder={kTrans("Enter campaign name")}
                disabled={isClosed}
              />
            </div>
            <div className="d-flex align-items-center">
              <Form.Check.Label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "4px",
                }}
              >
                {isActive == 1 ? "Active" : "Inactive"}
              </Form.Check.Label>
              <Form.Check.Input
                className="toggle-checkbox"
                value="1"
                defaultChecked={false}
                onChange={(e) => {
                  setIsActive(e.target.checked ? 1 : 0);
                }}
                name="isActive"
                checked={isActive == 1}
              />
            </div>
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <Form.Label>
              <b className="text-sm-start">{kTrans("Select content type")}</b>
            </Form.Label>
            <DropdownButton
              className="customDropdown w-25"
              id="contentType"
              title={
                contentTypesList.find((item) => item === contentTypeValue) ??
                "N/A"
              }
              disabled={isClosed}
              // onChange={(e) => handleChange(e)}
            >
              {contentTypesList && contentTypesList.length ? (
                contentTypesList.map((el, i) => (
                  <Dropdown.Item
                    key={i}
                    name="contentType"
                    onClick={(e) => handleContentTypeDDChange(e, el)}
                    as="button"
                  >
                    {el}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item>No responses available</Dropdown.Item>
              )}
            </DropdownButton>
          </Form.Group>

          <Form.Group className="border-bottom py-4">
            <Form.Check.Label>
              <b className="text-sm-start">
                {kTrans("Where would you like your campaign to run?")}
              </b>
            </Form.Check.Label>
            <div style={{ display: "flex", alignItems: "center" }}>
              {groups && groups.length > 1 && (
                <div style={{ minWidth: 200, marginRight: 16 }}>
                  <OrganizationSelector
                    defaultText="Select Group"
                    isShowTitle={false}
                    value={forGroups}
                    onChange={(e) => {
                      setForGroups(Array.isArray(e) ? e : [e]);
                      setForNetworks([]);
                    }}
                    preventSubmit={true}
                    groups={groups}
                    multiple={false}
                    isLoggedInUserSuperAdmin={isLoggedInUserSuperAdmin}
                  />
                </div>
              )}
              <DropdownButton
                className="customDropdown w-25 me-3 standard-dropdown"
                id="scope"
                title={campaignScope.find((item) => item === scope) ?? "N/A"}
                disabled={isClosed}
              >
                {campaignScope && campaignScope.length ? (
                  campaignScope.map((el, i) => (
                    <Dropdown.Item
                      key={i}
                      name="scope"
                      onClick={(e) => handleScopeDropdownChange(e, el)}
                      as="button"
                    >
                      {el}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item>No scope available</Dropdown.Item>
                )}
              </DropdownButton>
              {scope === "Specific Sites" && (
                <NetworksSelector
                  defaultText="Select Sites"
                  multiple={true}
                  value={forNetworks}
                  onChange={(e) => {
                    setForNetworks(e);
                    return false;
                  }}
                  networks={
                    forGroups.length > 0
                      ? groupNetworks.length > 0
                        ? groupNetworks
                        : allNetworks
                      : allNetworks
                  }
                  isShowTitle={false}
                  preventSubmit={true}
                />
              )}
            </div>
          </Form.Group>

          <Form.Group className="border-bottom py-4">
            <Form.Check.Label>
              <b className="text-sm-start">
                {kTrans("Select a poll, quiz, form or sequence")}
              </b>
            </Form.Check.Label>
            <Autosuggest
              suggestions={ctContentList}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              getSuggestionValue={(suggestion) => suggestion}
              renderSuggestion={(suggestion) => (
                <span className="customLabel">
                  {suggestion.contentTypeDesc}
                </span>
              )}
              inputProps={{
                placeholder: "Search",
                value: searchInput,
                className: "w-50 form-control",
                // disabled: { isClosed },
                onBlur: (e) => {
                  setSearchInput(cTypeTitle ?? "");
                },
                onChange: (e, { newValue }) => {
                  console.log("onChange Poll: ", newValue);
                  if (newValue && (newValue.contentTypeDesc || newValue.id)) {
                    setContentTypeValue(contentTypeValue);
                    setCTypeTitle(newValue.contentTypeDesc);
                    setCTypeId(newValue.id);
                    setSearchInput(newValue.contentTypeDesc);
                    e.preventDefault();
                  } else {
                    setSearchInput(e.target.value);
                  }
                },
              }}
              theme={{
                input: "form-control",
                // suggestionsContainer: "border mt-1 pt-2",
                suggestionsList: "list-group font-size-sm",
                suggestion: "list-group-item",
                suggestionHighlighted: "active",
              }}
            />
            {/* <span className="customLabel">
              {debateId ? debateId : "No poll selected"}
            </span> */}
          </Form.Group>

          <Form.Group className="border-bottom py-4">
            <div style={{ display: "flex" }}>
              <div className="d-flex flex-column">
                <Form.Label>
                  <b className="text-sm-start">
                    {kTrans("How many responses do you need?")}
                  </b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30"
                  id="responseCountTarget"
                  title={
                    responseList.find((item) => item === responseCountTarget) ??
                    "N/A"
                  }
                  disabled={isClosed}
                  // onChange={(e) => handleChange(e)}
                >
                  {responseList && responseList.length ? (
                    responseList.map((el, i) => (
                      <Dropdown.Item
                        key={i}
                        name="responseCountTarget"
                        onClick={(e) => handleResponseDropdownChange(e, el)}
                        as="button"
                      >
                        {el}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item>No responses available</Dropdown.Item>
                  )}
                </DropdownButton>
              </div>
              <div className="d-flex flex-column">&nbsp;&nbsp;&nbsp;&nbsp;</div>
              <div className="d-flex flex-column">
                <Form.Label>
                  <b className="text-sm-start">
                    {kTrans("Position of Poll in embed feed")}
                  </b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30"
                  id="slotNumber"
                  title={
                    slotNumberList.find((item) => item === slotNumber) ?? ""
                  }
                  disabled={isClosed}
                  // onChange={(e) => handleChange(e)}
                >
                  {slotNumberList && slotNumberList.length ? (
                    slotNumberList.map((el, i) => (
                      <Dropdown.Item
                        key={i}
                        name="slotNumber"
                        onClick={(e) => handleSlotNumberDropdownChange(e, el)}
                        as="button"
                      >
                        {el}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item>No responses available</Dropdown.Item>
                  )}
                </DropdownButton>
              </div>
            </div>
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <div
              className="text-left mb-6"
              style={{ fontSize: "14px", paddingBottom: "6px" }}
            >
              <strong>When should the campaign start and end?</strong>
            </div>
            <div
              className="inline-content top"
              style={{ justifyContent: "start" }}
            >
              <Form.Group controlId="startDate" className="me-3">
                {/* <Form.Label>Start Date </Form.Label> */}
                <div className="datePickerWrapper">
                  {startDate !== null ? (
                    <>
                      <DateRangePicker
                        onCallback={(e) => {
                          console.log("start date: ", e);
                          setStartDate(e);
                        }}
                        initialSettings={{
                          singleDatePicker: true,
                          // minDate: moment(),
                          startDate: startDate,
                          timePicker: true,
                          locale: {
                            format: "MM/DD/YY @ hh:mmA",
                          },
                        }}
                        disabled={isClosed}
                      >
                        <input
                          type="text"
                          name="startDate"
                          className="form-control datepickerField"
                          disabled={isClosed}
                        />
                      </DateRangePicker>
                      <i className="fa fa-calendar"></i>
                    </>
                  ) : null}
                </div>
              </Form.Group>
              <Form.Group controlId="endDate" className="">
                {/* <Form.Label>End Date</Form.Label> */}
                <div className="datePickerWrapper">
                  {endDate !== null ? (
                    <>
                      <DateRangePicker
                        onCallback={(e) => setEndDate(e)}
                        initialSettings={{
                          singleDatePicker: true,
                          // minDate: endedAtMinDate,
                          startDate: endDate["_d"],
                          /*maxDate: endedAtMaxDate,*/
                          timePicker: false,
                          locale: {
                            format: "MM/DD/YY @ hh:mmA",
                          },
                        }}
                        disabled={isClosed}
                      >
                        <input
                          type="text"
                          name="endDate"
                          className={`form-control datepickerField`}
                          disabled={isClosed}
                        />
                      </DateRangePicker>
                      <i className="fa fa-calendar"></i>
                    </>
                  ) : null}
                </div>
              </Form.Group>
            </div>
          </Form.Group>
          <Form.Group className="border-bottom py-4">
            <div className="d-flex align-items-center">
              <Form.Label
                htmlFor="isSponsored"
                className="mb-0"
                style={{ cursor: "pointer" }}
              >
                Sponsored?
              </Form.Label>
              <Form.Check
                type="checkbox"
                id="isSponsored"
                checked={isSponsored}
                onChange={(e) => setIsSponsored(e.target.checked ? 1 : 0)}
                disabled={isClosed}
              />
            </div>
          </Form.Group>
          <div className="d-flex pt-4">
            <button
              type="submit"
              className="blue-button size-l"
              disabled={isClosed}
            >
              {id > 0 ? "Update Campaign" : "Create Campaign"}
            </button>
            <Link to="/campaigns" className="btn btn-link">
              Cancel
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
  allNetworks: state.networks.networksList,
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps)(AddEditCampaign);
